import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { ErzeugungsanlageImportJob } from '../../domain/model/erzeugungsanlage-import-job';

@Injectable({
    providedIn: 'root',
})
export class ImportWizardUploadService {
    private http = inject(HttpClient);

    public async uploadExcelAsync(stadtwerkeId: string, file: File, dryRun: boolean): Promise<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);

        let params = new HttpParams();
        params = params.set('dryrun', dryRun);
        params = params.set('stadtwerkeId', stadtwerkeId);

        const req = new HttpRequest(
            'POST',
            environment.API_URL + '/erzeugungsanlage/async/erzeugungsanlagen.xlsx',
            formData,
            {
                reportProgress: true,
                params,
            });
        return await lastValueFrom(this.http.request(req));
    }

    public async checkImportJob(jobId: number): Promise<ErzeugungsanlageImportJob> {
        return await lastValueFrom(this.http.get<ErzeugungsanlageImportJob>(environment.API_URL + '/erzeugungsanlage/importjob/' + jobId));
    }

}
